export const SET_INDICATORS = 'SET_INDICATORS'
export const SET_VEHICLE = 'SET_VEHICLE'
export const SET_VEHICLES = 'SET_VEHICLES'
export const SET_GUESTS = 'SET_GUESTS'
export const CREATE_GUEST = 'CREATE_GUEST'
export const SET_EVENT = 'SET_EVENT'
export const SET_EVENTS = 'SET_EVENTS'
export const SET_PERMISSIONS = 'SET_PERMISSIONS'
export const SET_COMMAND_TRANSFER_STATUS = 'SET_COMMAND_TRANSFER_STATUS'
export const SET_CLIENT = 'SET_CLIENT'
export const SET_CLIENT_NAME = 'SET_CLIENT_NAME'
export const UNSHIFT_EVENT = 'UNSHIFT_EVENT'
export const UPDATE_POSITION = 'UPDATE_POSITION'
export const SET_SHAPES = 'SET_SHAPES'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js